import { Menu, NoResults, WhiteInstantSearchBuilder } from '@white-nl/instantsearch-components';
import { HitComponent, LoadingComponent } from '@white-nl/instantsearch-components/dist/types/components';
import Loading from '../components/categorySlider/results/Loading';
import initCategorySlider from '../../../components/CategorySlider';
import FlatMenu from '../components/catalog/refinements/FlatMenu/FlatMenu';
import { Hit } from '../components/catalog/results';

const sliders = document.querySelectorAll('.category-slider');
if (sliders.length > 0) {
  const sessionUrl = Craft.getSiteUrl('actions/users/session-info');
  fetch(sessionUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  }).then((res) => res.json())
    .then((sessionInfo) => {
      const apiUrl = Craft.getSiteUrl('api/react/catalog');
      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json())
        .then((data) => {
          const { translates, categories, wishlistIds } = data;
          const { catalog } = translates;

          sliders.forEach((slider) => {
            const settings = (slider as HTMLElement)?.dataset || null;
            if (settings && sessionInfo) {
              const indexName = settings.indexName || '';
              const uris = JSON.parse(settings.categoryUris || '[]');
              const whiteInstantSearchCategorySlider = new WhiteInstantSearchBuilder();
              whiteInstantSearchCategorySlider
                .withSearchkit(
                  indexName,
                  settings.publicUrl || '',
                  settings.jwt || '',
                  settings.refreshUrl || '',
                )
                .withoutRouting()
                .addAdditionalData({
                  translates,
                  hitClasses: 'swiper-slide aspect-10/13 max-w-40.75 xs:max-w-60 md:max-w-97.5 overflow-hidden',
                  backgroundColor: settings.bg ?? 'bg-light',
                  sessionInfo,
                  wishlistIds,
                })
                .addHitComponent([{
                  settings: {
                    noResults: {
                      translations: {
                        noResults: Craft.t(catalog, 'Sorry, we can\'t find any products!'),
                        refinements: Craft.t(catalog, 'Try to choose another category or filter.'),
                        query: Craft.t(catalog, 'Please try another query.'),
                      },
                    },
                  },
                  component: Hit as HitComponent,
                  loadingComponent: Loading as LoadingComponent,
                  noResultsComponent: NoResults,
                }], `#white-instant-search-hits-${settings.sliderId}`)
                .addMenu(
                  [
                    {
                      settings: {
                        attribute: 'categories.lvl2',
                        hardRefresh: false,
                        limit: 999,
                        transformItems: (items) => uris.map((uri: string) => (
                          {
                            label: categories[uri] ?? '',
                            value: uri,
                            count: 0,
                            isRefined: items.filter((item) => item.value === uri && item.isRefined).length > 0,
                            exhaustive: true,
                            data: null,
                          }
                        )),
                        classNames: {
                          label: 'group/label capitalize relative block text-gray-400 group-[.ais-Menu-item--selected]/item:text-dark cursor-pointer outline-none border-none hover:underline transition-all text-md lg:text-2xl',
                          count: 'hidden',
                          item: 'group/item swiper-slide w-auto! max-lg:first:ml-4 max-lg:last:mr-4',
                          list: 'list-none my-0 ml-0 swiper-wrapper',
                          root: 'swiper category-slider-nav-swiper',
                        },
                      },
                      component: Menu,
                    },
                  ],
                  `#white-instant-category-slider-menu-${settings.sliderId}`,
                )
                .addHierarchicalMenu([
                  {
                    settings: {
                      attributes: ['categories.lvl2'],
                      hardRefresh: true,
                      limit: 999,
                      transformItems: (items) => items.filter((item) => uris.includes(item.value))
                        .map((item) => (
                          {
                            ...item,
                            label: Craft.t(catalog, 'View All'),
                          }
                        )),
                      classNames: {
                        link: 'btn btn-link btn-arrow btn-xs',
                        count: 'btn btn-link btn-xs',
                        selectedItem: 'block!',
                        item: 'group/item hidden',
                        list: 'list-none my-0 ml-0',
                        root: 'max-lg:px-4 flex items-center justify-center mt-2 lg:mt-0 lg:absolute lg:top-0.5 lg:right-6 z-4',
                      },
                    },
                    component: FlatMenu,
                  },
                ], `#white-instant-search-view-all-${settings.sliderId}`)
                .setHitsPerPage(10)
                .afterFirstRender(() => initCategorySlider(settings.sliderId))
                .build()
                .show();
            }
          });
        });
    });
}
